"use strict";
// This file declares a re-exports the tree grid selection classes and types in their own module.
Object.defineProperty(exports, "__esModule", { value: true });
var TreeGridSelection_1 = require("./TreeGridSelection");
exports.TreeGridSelection = TreeGridSelection_1.TreeGridSelection;
//# sourceMappingURL=ExportTreeGridSelection.js.map